module.exports = __webpack_public_path__ + "img/SFAR_logo.03045482.jpg";